import { utils, isValid, OpenAttestationEthereumDocumentStoreStatusCode } from '@tradetrust-tt/tt-verify';
import { W3CCredentialStatusCode } from '../../verify/fragments/document-status/w3cCredentialStatus';
import { TYPES } from '../errorMessages/VerificationErrorMessages';
import { errorMessages } from '../errorMessages';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const certificateRevokedOnDidIdentified = /* @__PURE__ */ __name((fragments) => {
  const didSignedDocumentStatusFragment = utils.getOpenAttestationDidSignedDocumentStatusFragment(fragments);
  return didSignedDocumentStatusFragment?.reason?.code === OpenAttestationEthereumDocumentStoreStatusCode.DOCUMENT_REVOKED;
}, "certificateRevokedOnDidIdentified");
const interpretFragments = /* @__PURE__ */ __name((fragments) => {
  const hashValid = isValid(fragments, ["DOCUMENT_INTEGRITY"]);
  const issuedValid = isValid(fragments, ["DOCUMENT_STATUS"]);
  const identityValid = isValid(fragments, ["ISSUER_IDENTITY"]);
  return { hashValid, issuedValid, identityValid };
}, "interpretFragments");
const OAErrorMessageHandling = /* @__PURE__ */ __name((fragments) => {
  const { hashValid, issuedValid, identityValid } = interpretFragments(fragments);
  const errors = [];
  if (utils.isDocumentStoreAddressOrTokenRegistryAddressInvalid(fragments)) {
    return [TYPES.ADDRESS_INVALID];
  }
  if (utils.contractNotFound(fragments)) {
    return [TYPES.CONTRACT_NOT_FOUND];
  }
  if (utils.serverError(fragments)) {
    return [TYPES.SERVER_ERROR];
  }
  if (!hashValid) errors.push(TYPES.HASH);
  if (!identityValid) errors.push(TYPES.IDENTITY);
  if (!issuedValid) {
    if (utils.certificateRevoked(fragments) || certificateRevokedOnDidIdentified(fragments))
      errors.push(TYPES.REVOKED);
    else if (utils.invalidArgument(fragments)) {
      errors.push(TYPES.INVALID_ARGUMENT);
    } else if (utils.certificateNotIssued(fragments)) errors.push(TYPES.ISSUED);
    else if (!hashValid && !identityValid) {
      return [TYPES.INVALID];
    } else {
      return [TYPES.ETHERS_UNHANDLED_ERROR];
    }
  }
  return errors;
}, "OAErrorMessageHandling");
const getW3CCredentialStatusFragment = utils.getFragmentByName(
  "W3CCredentialStatus"
);
const w3cCredentialStatusRevoked = /* @__PURE__ */ __name((fragments) => {
  const issuedFragment = getW3CCredentialStatusFragment(fragments);
  return issuedFragment?.reason?.code === W3CCredentialStatusCode.DOCUMENT_REVOKED || issuedFragment?.reason?.code === W3CCredentialStatusCode.DOCUMENT_REVOKED_AND_SUSPENDED;
}, "w3cCredentialStatusRevoked");
const w3cCredentialStatusSuspended = /* @__PURE__ */ __name((fragments) => {
  const issuedFragment = getW3CCredentialStatusFragment(fragments);
  return issuedFragment?.reason?.code === W3CCredentialStatusCode.DOCUMENT_SUSPENDED || issuedFragment?.reason?.code === W3CCredentialStatusCode.DOCUMENT_REVOKED_AND_SUSPENDED;
}, "w3cCredentialStatusSuspended");
const errorMessageHandling = /* @__PURE__ */ __name((fragments) => {
  const { hashValid, issuedValid, identityValid } = interpretFragments(fragments);
  const errors = [];
  const isW3cFragments = fragments.some(
    (f) => f.name.startsWith("W3C") || f.name === "TransferableRecords"
  );
  if (isW3cFragments) {
    switch (true) {
      case w3cCredentialStatusRevoked(fragments):
        errors.push(errorMessages.TYPES.REVOKED);
        break;
      case w3cCredentialStatusSuspended(fragments):
        errors.push(errorMessages.TYPES.SUSPENDED);
        break;
      case !hashValid:
        errors.push(errorMessages.TYPES.HASH);
        break;
      case !identityValid:
        errors.push(errorMessages.TYPES.IDENTITY);
        break;
      case !issuedValid:
        errors.push(errorMessages.TYPES.INVALID);
        break;
    }
    return errors;
  } else return OAErrorMessageHandling(fragments);
}, "errorMessageHandling");

export { OAErrorMessageHandling, errorMessageHandling, interpretFragments, w3cCredentialStatusRevoked, w3cCredentialStatusSuspended };
